import React from 'react';
import useAuthObjectUrl from '../../hooks/useAuthObjectUrl';

const SecureImage = ({
  src,
  alt,
  fallbackSrc = null,
  loadingFallback = null,
  errorFallback = null,
  className = '',
}) => {
  const shouldFetch = Boolean(src);
  const { data: objectUrl, error } = useAuthObjectUrl(shouldFetch ? src : null);

  if (error) {
    if (fallbackSrc) {
      return <img src={fallbackSrc} alt={alt} className={className} />;
    }
    return errorFallback || <p className="secure-image__error">Unable to load image.</p>;
  }

  if (objectUrl) {
    return <img src={objectUrl} alt={alt} className={className} />;
  }

  if (fallbackSrc) {
    return <img src={fallbackSrc} alt={alt} className={className} />;
  }

  if (shouldFetch) {
    return loadingFallback || <p className="secure-image__loading">Loading…</p>;
  }

  return errorFallback || <p className="secure-image__empty">Image not available.</p>;
};

export default SecureImage;
